// extracted by mini-css-extract-plugin
export var quantityInput = "_ge-0";